import { useCallback, useEffect, useMemo, useRef } from "react";
import styles from "./index.module.less";
import React, { useState } from "react";
import { useUser } from "@/utils/UserContext";
import {
  getKsDict,
  getDictIdByCode,
  getDictListById,
  addDictItem,
} from "@/services/history";
import { editJudge } from "@/services/judge";
import { getCode, verifySmsCode } from "@/services/user";
import { cloneDeep } from "lodash-es";
import unKnownJudges from "@/assets/img/unKnownJudges.png";
import {
  InputField,
  SelectField,
  ButtonField,
  Iconsvg,
  Combobox,
  TextareaField,
  ComboboxSuggestion,
} from "@wk/components-react16";
import { useNavigate } from "react-router-dom";
import AddYyModal from "../../player/modal/addYy";
import ModalConfirm from "../../player/modal";
import ChangeHeaderPic from "../changeHeaderPic";
import CropPicModal from "../cropPicModal";
import { TreeSelect } from "antd";
const phoneRegex = /^1[3-9]\d{9}$/;

const JudgesHomepageDetail = () => {
  const { judge, setJudgeInfo } = useUser();
  const navigate = useNavigate();

  const [userInfo, setUserInfo] = useState();
  const [ksList, setKsList] = useState([]);
  const [zcList, setZcList] = useState([]);
  const [yyList, setYyList] = useState([]);
  const [nameStatus, setNameStatus] = useState("none");
  const [isYyDropdownOpen, setIsYyDropdownOpen] = useState(false);
  const [yyComboboxInputValue, setYyComboboxInputValue] = useState("");
  const [yyComboboxValue, setYyComboboxValue] = useState({});

  const [isAddYyOpen, setIsAddYyOpen] = useState(false);
  const [isAddYyLoading, setIsAddYyLoading] = useState(false);
  const fileInputRef = useRef(null);

  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [isSaveOpen, setIsSaveOpen] = useState(false);
  const [isSaveConfirm, setIsSaveConfirm] = useState(false);

  const [inputStatus, setInputStatus] = useState("none");

  const [codeValue, setCodeValue] = useState("");
  const [codeStatus, setCodeStatus] = useState("none");

  const [second, setSecond] = useState(0);
  const [isNextLoading, setIsNextLoading] = useState(false);

  const [isMessageOpen, setIsMessageOpen] = useState(false);
  const [messageText, setMessageText] = useState("");

  const [isMessageSendOpen, setIsMessageSendOpen] = useState(false);

  const [isHeaderPicOpen, setIsHeaderPicOpen] = useState(false);
  const [isCropPicModalOpen, setIsCropPicModalOpen] = useState(false);
  const cropPicModalRef = useRef(null);

  const nameErrorText = useMemo(() => {
    if (nameStatus === "none") {
      return [];
    }
    if (!userInfo?.userName) {
      return [{ label: "请输入选手姓名", labelId: "1" }];
    }

    if (userInfo?.userName.length < 2) {
      return [{ label: "请输入至少2个字符", labelId: "2" }];
    }

    return [];
  }, [nameStatus, userInfo?.userName]);

  const errorText = useMemo(() => {
    if (inputStatus === "none") {
      return [];
    }
    if (!userInfo?.phone) {
      return [{ label: "请输入手机号", labelId: "1" }];
    }

    const phoneRegex = /^1[3-9]\d{9}$/;
    if (!phoneRegex.test(userInfo?.phone)) {
      return [{ label: "请输入正确的手机号", labelId: "2" }];
    }
  }, [inputStatus, userInfo?.phone]);

  const errorCodeText = useMemo(() => {
    if (codeStatus === "none") {
      return [];
    }
    if (!codeValue) {
      return [{ label: "请输入验证码", labelId: "1" }];
    }

    return [{ label: "验证码错误", labelId: "2" }];
  }, [codeStatus, codeValue]);

  const getCaseTypeDict = async (code) => {
    try {
      const resList = await getDictIdByCode({ code });
      const id = resList?.result?.records[0]?.id || "";
      const itemList = await getDictListById({ dictId: id, pageSize: -1 });
      return itemList?.result?.records || [];
    } catch (error) {
      return [];
    }
  };

  const getZcList = async () => {
    const zcList = await getCaseTypeDict("zc");
    setZcList(zcList);
  };

  const getYyList = async (value) => {
    const yyList = await getCaseTypeDict("yy");
    setYyList(yyList);
    if (value) {
      let itemFind = yyList.find((item) => {
        return item?.itemValue === value;
      });
      if (itemFind) {
        // setYyComboboxValue(itemFind);
        setUserInfo((prev) => {
          return {
            ...prev,
            institution: itemFind?.id,
          };
        });
      }
    }
  };

  const onClear = () => {
    setYyComboboxInputValue("");
    // setYyComboboxValue({});
    // setUserInfo({ ...userInfo, institution: "" });
  };

  const onInputClick = () => {
    setIsYyDropdownOpen(true);
  };

  const onKey = (e) => {
    const { value } = e.target;
    setYyComboboxInputValue(value);
    if (value !== "") {
      setIsYyDropdownOpen(true);
    }
  };

  const addYy = async (value, callBack) => {
    setIsAddYyLoading(true);

    try {
      const res = await getDictIdByCode({ code: "yy" });
      if (!res?.success || !res?.result?.records?.length) {
        setIsAddYyLoading(false);
        return;
      }

      const dictId = res?.result?.records[0]?.id;
      // const checkRes = await checkDict({ dictId, itemValue: value.value });
      // if (checkRes?.code !== 200) {
      //   setIsAddYyLoading(false);
      //   setIsValueError(true);
      //   return;
      // }

      const resAdd = await addDictItem({
        dictId,
        itemText: value.name,
        itemValue: value.value,
      });
      if (resAdd?.code === 200) {
        await getYyList(value.value);
        setIsAddYyOpen(false);
        callBack();
      }
    } catch (error) {
      setIsAddYyLoading(false);
    }

    setIsAddYyLoading(false);
  };

  const getFilteredOptions = useCallback(() => {
    const value = cloneDeep(yyComboboxInputValue);

    if (yyComboboxValue?.itemText === value) {
      return yyList;
    }

    const filteredOptions = yyList.filter((item) => {
      return item?.itemText.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    });

    if (filteredOptions.length === 0) {
      return [{ itemText: `+ 添加机构 ${value}`, id: "create" }];
    }

    return filteredOptions;
  }, [yyComboboxInputValue, yyComboboxValue, yyList]);

  const onComboboxValueChange = (e) => {
    setIsYyDropdownOpen(false);

    if (e?.id !== "create") {
      setYyComboboxInputValue(e?.itemText);
      setYyComboboxValue(e);
      setUserInfo({ ...userInfo, institution: e?.id });
    } else {
      setIsAddYyOpen(true);
    }
  };

  const sendCode = async () => {
    if (!userInfo?.phone || !phoneRegex.test(userInfo?.phone)) {
      setInputStatus("error");
      return;
    }

    setIsNextLoading(true);

    const resCode = await getCode(userInfo?.phone);
    // 开始倒计时
    let time = 60;
    setSecond(--time);
    let clearTimer = setInterval(() => {
      setSecond(--time);
      if (time < 1) {
        clearInterval(clearTimer);
      }
    }, 1000);

    if (resCode.code === 200) {
      setMessageText("短信验证码发送成功，请注意查收");
      setIsMessageSendOpen(true);
    } else if (resCode.code === 500) {
      setMessageText("短信验证码发送失败，请稍后重试");
      setIsMessageSendOpen(true);
    }
    setTimeout(() => {
      setIsMessageSendOpen(false);
    }, 3000);

    setIsNextLoading(false);
  };

  // 验证验证码，并提交
  const submit = async (isCancel = false) => {
    setIsSaveOpen(false);
    if (!userInfo?.userName || userInfo?.userName.length < 2) {
      setNameStatus("error");
      return;
    }
    if (!userInfo?.phone || !phoneRegex.test(userInfo?.phone)) {
      setInputStatus("error");
      return;
    }

    if (!codeValue) {
      setCodeStatus("error");
      return;
    }
    const value = cloneDeep(userInfo);
    setIsSaveLoading(true);

    try {
      const res = await verifySmsCode(codeValue, value?.phone);
      if (res?.code === 200) {
        if (res?.result) {
          if (isCancel) {
            save(true);
          } else {
            // 打开弹窗
            save(true);
          }
        }
      }
      if (res?.code === 500) {
        setCodeStatus("error");
      }
    } catch (error) {
      setMessageText("网络异常，请稍后重试");
      setIsMessageOpen(true);
    } finally {
      setIsSaveLoading(false);
    }
  };

  const save = async () => {
    if (!userInfo?.userName || userInfo?.userName.length < 2) {
      setNameStatus("error");
      return;
    }

    if (!userInfo?.phone || !phoneRegex.test(userInfo?.phone)) {
      setInputStatus("error");
      return;
    }

    if (!codeValue) {
      setCodeStatus("error");
      return;
    }

    const value = cloneDeep(userInfo);

    if (!value?.id) {
      return;
    }

    setIsSaveLoading(true);
    try {
      await editJudge(value);
    } catch (error) {
      setMessageText("网络异常，请稍后重试");
      setIsMessageOpen(true);
    } finally {
      setIsSaveConfirm(false);
      setIsSaveLoading(false);
      setJudgeInfo(value);
      setIsSaveOpen(false);
      navigate("/judgesHomepage");
    }
  };

  const changeUserHeaderPic = (url) => {
    setUserInfo({
      ...userInfo,
      pic: url,
    });
  };

  const messageOpen = (text) => {
    setMessageText(text);
    setIsMessageOpen(true);
  };

  const clickPicFileInput = (e) => {
    // 阻止事件冒泡
    e.stopPropagation();
    fileInputRef.current?.click();
  };

  useEffect(() => {
    const value = cloneDeep(judge);
    setUserInfo(value);
  }, [judge]);

  useEffect(() => {
    const value = cloneDeep(userInfo);
    let itemFind = yyList.find((item) => {
      return item?.id === value?.institution;
    });

    if (itemFind) {
      setYyComboboxValue(itemFind);
      setYyComboboxInputValue(itemFind?.itemText);
    }
  }, [userInfo, yyList]);

  useEffect(() => {
    getKsDict().then((res) => {
      setKsList(res.result || []);
    });
    getZcList();
    getYyList();
  }, []);

  return (
    <div className={styles["judges-homepage-detail-box"]}>
      <div className="player-info">
        <div className="title">评委个人信息</div>
        <div className="header-img-box">
          <img
            src={userInfo?.pic || unKnownJudges}
            alt=""
            className="header-img"
            onClick={() => setIsHeaderPicOpen(true)}
          />

          <input
            type="file"
            ref={fileInputRef}
            accept=".jpg,.jpeg,.png,.gif,.bmp,.webp"
            style={{ display: "none" }}
            onChange={(e) => {
              const file = e.target.files[0];

              if (file) {
                let testmsg = /^image\/(jpeg|png|jpg|svg|bmp)$/.test(file.type);
                const isLt20MB = file.size / 1024 / 1024 <= 2; //图片大小不超过2MB
                if (!testmsg) {
                  setMessageText("请上传正确的图片格式");
                  setIsMessageOpen(true);
                  return;
                }
                if (!isLt20MB) {
                  setMessageText("图片大小不能超过2MB");
                  setIsMessageOpen(true);

                  return;
                }
                setIsCropPicModalOpen(true);

                cropPicModalRef.current.headerPicSelect(e);
              }
              setTimeout(() => {
                fileInputRef.current.value = "";
              }, 200);
            }}
          />
          <div className="photo-icon" onClick={clickPicFileInput}>
            <Iconsvg name="photo" size={16} color="#353535" />
          </div>
        </div>
        <div className="info">
          <div className="left">
            <InputField
              label="评委姓名"
              labelFor="input-id-1-1"
              indicator="required"
              status={nameStatus}
              errors={nameErrorText}
            >
              <input
                type="text"
                id="input-id-1-1"
                name="input-1-1"
                placeholder="请输入选手姓名"
                required
                value={userInfo?.userName}
                onChange={(e) => {
                  setUserInfo({ ...userInfo, userName: e.target.value });
                  if (!e.target.value || e.target.value.length < 2) {
                    setNameStatus("error");
                    return;
                  }

                  setNameStatus("none");
                }}
                maxLength={16}
                minLength={2}
              />
            </InputField>

            <InputField
              label="手机号码"
              labelFor="input-id-2-1"
              indicator="required"
              status={inputStatus}
              errors={errorText}
            >
              <input
                type="text"
                id="input-id-2-1"
                name="input-2-1"
                placeholder="请输入手机号码"
                required
                value={userInfo?.phone}
                onChange={(e) => {
                  setUserInfo({ ...userInfo, phone: e.target.value });

                  if (!e.target.value || !phoneRegex.test(e.target.value)) {
                    setInputStatus("error");
                    return;
                  }

                  setInputStatus("none");
                }}
                maxLength="11"
              />
            </InputField>

            <Combobox
              isOpen={isYyDropdownOpen}
              hasClearButton={isYyDropdownOpen && yyComboboxInputValue}
              onDropdownUserRequest={(event) => {
                setIsYyDropdownOpen(event);
                setYyComboboxInputValue(yyComboboxValue.itemText);
              }}
              onClearUserRequest={onClear}
              label="机构"
            >
              <input
                placeholder="请选择机构"
                value={yyComboboxInputValue}
                onClick={onInputClick}
                onInput={(event) => onKey(event)}
                slot="comboboxInput"
                maxLength={20}
              />
              {Object.values(getFilteredOptions()).map((item, idx) => {
                return (
                  <React.Fragment key={item.id}>
                    <ComboboxSuggestion
                      isSelected={item.id === yyComboboxValue.id}
                      onItemClick={() => onComboboxValueChange(item)}
                      slot="comboboxSuggestion"
                    >
                      {item.itemText}
                    </ComboboxSuggestion>
                  </React.Fragment>
                );
              })}
            </Combobox>
          </div>

          <div className="right">
            <SelectField label="职称" labelFor="select-id-1-1">
              <select
                id="select-id-1-1"
                name="story1-1"
                value={userInfo?.experience || ""}
                onChange={(e) => {
                  setUserInfo({ ...userInfo, experience: e.target.value });
                }}
              >
                <option disabled hidden value={""}>
                  请选择职称或职务
                </option>
                {zcList.map((item) => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item.itemText}
                    </option>
                  );
                })}
              </select>
            </SelectField>

            {/* 验证码 */}
            <div className="code-box">
              <InputField
                label="验证码"
                labelFor="input-id-1-3"
                indicator="required"
                status={codeStatus}
                errors={errorCodeText}
              >
                <input
                  type="text"
                  id="input-id-1-3"
                  name="input-1-3"
                  placeholder="请输入验证码"
                  value={codeValue}
                  onChange={(e) => {
                    setCodeValue(e.target.value);
                    if (!e.target.value) {
                      setCodeStatus("error");
                      return;
                    }
                    setCodeStatus("none");
                  }}
                  maxLength="6"
                />
              </InputField>

              <ButtonField mode={"ghost"}>
                <button
                  type="button"
                  onClick={() => sendCode()}
                  disabled={
                    isNextLoading ||
                    !(second < 1) ||
                    !userInfo?.phone ||
                    !phoneRegex.test(userInfo?.phone)
                  }
                >
                  {second < 1 ? "发送验证码" : `(${second}s后重发)`}

                  {isNextLoading && (
                    <Iconsvg name="spinner-alt" isSpin></Iconsvg>
                  )}
                </button>
              </ButtonField>
            </div>

            <div className="department">
              <div className="header">科室</div>
              <TreeSelect
                style={{ width: "100%" }}
                value={userInfo?.dept}
                styles={{
                  popup: { root: { maxHeight: 400, overflow: "auto" } },
                }}
                treeData={ksList}
                placeholder="请选择科室"
                treeDefaultExpandAll
                onChange={(value) => {
                  setUserInfo({ ...userInfo, dept: value });
                }}
                // multiple
                // maxCount={5}
                size="large"
                showSearch
                treeNodeFilterProp="title"
                fieldNames={{
                  value: "key",
                }}
              />
            </div>
          </div>
        </div>

        <TextareaField label="个人简介">
          <textarea
            value={userInfo?.introduction}
            placeholder="请输入内容"
            required
            onChange={(e) => {
              setUserInfo({ ...userInfo, introduction: e.target.value });
            }}
            maxLength={200}
          ></textarea>
        </TextareaField>

        <div className="btns">
          <ButtonField mode={"ghost"}>
            <button
              type="button"
              onClick={() => {
                setIsSaveOpen(true);
              }}
              disabled={isSaveLoading || !userInfo?.id}
            >
              取消
            </button>
          </ButtonField>

          <ButtonField>
            <button
              type="button"
              onClick={() => {
                submit();
              }}
              disabled={isSaveLoading || !userInfo?.id}
            >
              保存修改
              {isSaveLoading && <Iconsvg name="spinner-alt" isSpin></Iconsvg>}
            </button>
          </ButtonField>
        </div>
      </div>

      <ChangeHeaderPic
        src={userInfo?.pic || ""}
        isHeaderPicOpen={isHeaderPicOpen}
        setIsHeaderPicOpen={setIsHeaderPicOpen}
        changeUserHeaderPic={changeUserHeaderPic}
        clickPicFileInput={clickPicFileInput}
      />

      <CropPicModal
        ref={cropPicModalRef}
        isCropPicModalOpen={isCropPicModalOpen}
        setIsCropPicModalOpen={setIsCropPicModalOpen}
        changeUserHeaderPic={changeUserHeaderPic}
        messageOpen={messageOpen}
      />

      <ModalConfirm
        isOpen={isSaveOpen}
        onClose={() => {
          setIsSaveOpen(false);
          navigate("/judgesHomepage");
        }}
        children={
          <div className="modal-body-text">是否需要保存已填写信息?</div>
        }
        title={"操作确认"}
        onConfirm={() => submit(true)}
        isConfirmLoading={isSaveLoading}
        okText="确定"
      />

      <ModalConfirm
        isOpen={isSaveConfirm}
        onClose={() => {
          setIsSaveConfirm(false);
        }}
        children={<div className="modal-body-text">是否保存修改?</div>}
        title={"操作确认"}
        onConfirm={() => save()}
        isConfirmLoading={isSaveLoading}
        okText="确定"
      />

      <AddYyModal
        nameValue={yyComboboxInputValue}
        isOpen={isAddYyOpen}
        onClose={() => {
          setIsAddYyOpen(false);
          setIsAddYyLoading(false);
        }}
        title="添加机构"
        onConfirm={(value, callBack) => {
          addYy(value, callBack);
        }}
        isConfirmLoading={isAddYyLoading}
        height="auto"
        okText="提交"
      />

      <ModalConfirm
        isOpen={isMessageOpen}
        onClose={() => {
          setIsMessageOpen(false);
          setMessageText("");
        }}
        children={<div className="modal-body-text">{messageText}</div>}
        title={"操作确认"}
        onConfirm={() => {
          setIsMessageOpen(false);
          setMessageText("");
        }}
        okText="确认"
      />

      <ModalConfirm
        height="188px"
        isFooter={false}
        isOpen={isMessageSendOpen}
        onClose={() => {
          setIsMessageOpen(false);
          setMessageText("");
        }}
        children={<div className="modal-body-text">{messageText}</div>}
        title={"消息提示"}
        onConfirm={() => {
          setIsMessageOpen(false);
          setMessageText("");
        }}
        okText="确认"
      />
    </div>
  );
};
export default JudgesHomepageDetail;
